import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { NhapKhoVer2Service } from '../phieu-nhap-kho-ver2-service/phieu-nhap-kho-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { ChiTietPhieuNhapKho, PhieuNhapKho, NguoiThucHienNhapKho } from '../phieu-nhap-kho-ver2-model/phieu-nhap-kho-ver2.model';
import { DeNghiNhapKhoChiTiet } from '../../kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
//Component
import { ThongTinHangVeListDialogComponent } from '../thong-tin-hang-ve-list-dialog/thong-tin-hang-ve-list-dialog.component';
import { DNNKListDialogComponent } from '../de-nghi-nhap-kho-list-dialog/de-nghi-nhap-kho-list-dialog.component';
import { SoDoKhoViewComponent } from '../../so-do-kho/so-do-kho-view-dialog/so-do-kho-view-dialog.component';
import { SoDoKhoViewVer2Component } from '../../so-do-kho/so-do-kho-view-dialog-ver2/so-do-kho-view-dialog-ver2.component';
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-phieu-nhap-kho-ver2-add-edit',
	templateUrl: './phieu-nhap-kho-ver2-add-edit.component.html',
	styleUrls: ['../phieu-nhap-kho-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class PhieuNhapKhoAddEditVer2Component implements OnInit{

	/* Các trường focus cho các tag trong form */
	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport : ElementRef;
	@ViewChildren('focusDetail') focusDetail;


	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
	
	
    /*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	tmpAvailableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	phieuTTHVColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDN',
            displayName: 'Số phiếu TTHV',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	phieuDNNKColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDNNK',
            displayName: 'Số phiếu ĐNNK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoluongchungtuDNNK',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];
	/* ------------------------------------------------------------------*/
	
	
    /*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------ */
	
	
    /*--------------------Mat select search cho nhân viên-----------------*/
	listIdNV : any[] = [];
	selectIdNV : string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	/* ------------------------------------------------------------------ */


    /*-------------------- Mat select search cho kho ---------------------*/
	listKho : any[] = [];
	selectKho : string = '';
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
	haveElementKho: boolean = false;
	arrayKhoForEachHH: any[] = [];

	listKhoVer2 : any[] = [];
	selectKhoVer2 : string = '';
	filteredKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrlVer2: string = '';
	haveElementKhoVer2: boolean = false;
	/* ------------------------------------------------------------------ */

	
	/*----------------- Mat select search cho vị trí kho -----------------*/
	SaveListVTK: any[] = [];
	selectVTKho : string = '';
	filteredVTKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrl: string = '';
	arrayVTKhoForEachHH: any[] = [];

	ListVTKVer2: any[] = [];
	selectVTKhoVer2: string = '';
	filteredVTKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrlVer2: string = '';
	/* ------------------------------------------------------------------ */
	

  	/*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */
	
	
    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietPhieuNhapKho>(true, []);
    /* ------------------------------------------------------------------ */
	
	
    /* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */
	

	/* ------------------- Các form trên dialog --------------------------*/
	NKForm: FormGroup;				        //Form thông tin nhập kho
	HHForm: FormGroup;			            //Form add hàng hóa cho phiếu
	ImportHHForm: FormGroup;			    //Form import hàng hóa cho phiếu
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	NKItem: PhieuNhapKho;
	listChiTietNK: ChiTietPhieuNhapKho[] = [];
	tmpChiTietNK: ChiTietPhieuNhapKho[] = [];
	
	/* Danh sách tạm chi tiết đề nghị nhập kho để so sánh khi nhập số lượng trên lưới */
	deNghiNhapKhoResult: DeNghiNhapKhoChiTiet[] = [];

	/*Danh sách lưu ID các mặt hàng thêm mới cũng như đã xóa để lấy danh sách hàng hợp lý */
	deletedItems: number[] = [];
	addNewItems: number[] = [];
	/* ------------------------------------------------------------------ */
	

	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					
	previousIndex: number; 				
	fixedPoint = 2;                		
	isChange: boolean = false;			
	saveAdded: number[] = []		    
	saveAddedCT: number[] = []	
	viewLoading: boolean = false;   	
    disableNewButton: boolean = true;	
	listNguoiThucHien: string[] = [];   
	processImport: boolean = false;		
	flagTab: number = 0;				
	minDate: any;
	openTimKiemNangCao = false;
	optionsLoaiPhieu: any[] = [];
	flagChangeLoaiPhieu = "";
    /* ------------------------------------------------------------------ */
    

    constructor(
		public dialogRef: MatDialogRef<PhieuNhapKhoAddEditVer2Component>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private nhapKhoService: NhapKhoVer2Service,
		private NKFB: FormBuilder,
		private HHFB: FormBuilder,
		private ImportFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private dungChungService: DungChungService,
		) { 
			this.dialogRef.disableClose = true;
		}


    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load all dropdown and create form */
		this.ListId_HH();
		this.ListKho();
		this.ListKhoVer2();
		this.ListState();
		this.ListIdNv();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.NKItem = this.data.data;
		this.title = this.getTitle();
		this.optionsLoaiPhieu = PhieuNhapKho.optionsLoaiPhieu;
		
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape" && !this.openTimKiemNangCao) {
				this.back();
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode && !this.processImport) {
				this.onSubmit(1);
			}
			else if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode && !this.processImport){
				this.onSubmit(2);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode && !this.processImport) {
				this.onSubmit(3);
			}
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.IMPORT.KeyCombine.keycode
				&& this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho khác'
				&& this.flagTab == 1) {
				this.selectFile();
			}
			this.changeDetectView();
		});

        /* Filter list Hang hoa when value change*/
        this.HHForm.get('MaHang').valueChanges.subscribe(newValue=>{
            this.filterId_HH(newValue);
		})

		this.nhapKhoService.data_import.subscribe(res => {
			if(res != null && res != undefined && res.length > 0){
				res.forEach(element =>{
					const _detail = new ChiTietPhieuNhapKho();
					_detail.clear();
					_detail.isError = element.isError;
					_detail.messageError = element.messageError;

					let errorMessageArray = _detail.messageError.split(",");
					if(errorMessageArray != null && errorMessageArray != undefined){
						for(let i = 0; i < errorMessageArray.length; i++){
							
							switch (i) {
								case 0:{
									if(errorMessageArray[i] == "null"){
										let index = this.listId_HH.findIndex(x => x.MaHH == element.MaHH)
										if(index > -1){
											_detail.IdHh = this.listId_HH[index].Id_HH
											_detail.MaHH = this.listId_HH[index].MaHH;
											_detail.TenHH = this.listId_HH[index].TenHH;
											_detail.QuyCach = this.listId_HH[index].QuyCach;
											_detail.TenDVT = this.listId_HH[index].TenDVT;
											_detail.Dvt = this.listId_HH[index].DVT;
										}
										else{
											_detail.isError = true;
											_detail.MaHH = element.MaHH;
											errorMessageArray[i] = "Không tìm thấy mã hàng tương ứng; ";
										}
									}
									else{
										_detail.isError = true;
										element.MaHH == null ? errorMessageArray[i] = "Mã hàng hóa không được để trống; " : null;
									}
									break;
								}
								case 1:{
									if((_detail.IdHh == null || _detail.IdHh == undefined || _detail.IdHh <= 0)
									&& element.TenHH != null  && element.TenHH != undefined && element.TenHH != ''){
										let index = this.listId_HH.findIndex(x => x.TenHH == element.TenHH)
										if(index > -1){
											_detail.IdHh = this.listId_HH[index].Id_HH
											_detail.MaHH = this.listId_HH[index].MaHH;
											_detail.TenHH = this.listId_HH[index].TenHH;
											_detail.QuyCach = this.listId_HH[index].QuyCach;
											_detail.TenDVT = this.listId_HH[index].TenDVT;
											_detail.Dvt = this.listId_HH[index].DVT;

											_detail.isError = false;
											errorMessageArray[i - 1] = "";
										}
										else{
											_detail.isError = true;
											_detail.TenHH = element.TenHH;
											errorMessageArray[i] = "Không tìm thấy tên hàng tương ứng; ";
										}
									} 
									break;
								}
								case 2:{
									if((_detail.IdHh == null || _detail.IdHh == undefined || _detail.IdHh <= 0)
									&& element.TenDVT != null  && element.TenDVT != undefined && element.TenDVT != ''){
										_detail.TenDVT = element.TenDVT
									}
									break;
								}
								case 3:{
									element.Solo == null ? errorMessageArray[i] = "Số lô không được để trống; " 
															: _detail.Solo = element.Solo;
									break;
								}
								case 4:{
									element.Soluongthucnhap == null ? errorMessageArray[i] = "Số lượng bị lỗi, vui lòng kiểm tra lại; " 
																	: _detail.Soluongthucnhap = element.Soluongthucnhap;
									break;
								}
								case 5:{
									if(errorMessageArray[i] == "null"){
										//Regex cho ngày tháng dạng dd/mm/yyyy hoặc dd-mm-yyyy hoặc dd.mm.yyyy
										var regex = this.CONFIG.REGEX_STR_TO_DDMMYYYY;
										var found = element.Handung.match(regex);
										if(found != null){
											var dateParts = element.Handung.split("/");
											var dateObject = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
											_detail.Handung = moment(dateObject).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
										}
										else{
											_detail.isError = true;
											errorMessageArray[i] = "Lỗi định dạng ngày tháng hạn sử dụng, vui lòng kiểm tra lại; "
										}	
									}
									else{
										_detail.isError = true;
										element.Handung == null ? errorMessageArray[i] = "Hạn sử dụng bị lỗi, vui lòng kiểm tra lại; " : null;
									}
									break;
								}
								case 6:{
									if(errorMessageArray[i] == "null"){
										let index = this.listKho.findIndex(x => x.MaKho == element.MaKho)
										if(index > -1){
											_detail.IdKho = this.listKho[index].Id_Kho
											_detail.MaKho = this.listKho[index].MaKho;
											_detail.TenKho = this.listKho[index].TenKho;
										}
										else{
											_detail.isError = true;
											errorMessageArray[i] = "Không tìm thấy mã kho tương ứng";
										}
									}
									else{
										_detail.isError = true;
										element.MaKho == null ? errorMessageArray[i] = "Mã kho không được để trống" : null;
									}
									break;
								}
								case 7:{
									if(_detail.IdKho > 0 ){
										if(element.ViTriKho != null && element.ViTriKho != undefined && element.ViTriKho != '')
											_detail.ViTriKho = element.ViTriKho
									}
									else{
										_detail.isError = true;
										_detail.ViTriKho = element.ViTriKho;
										errorMessageArray[i] = "Không có kho để chọn vị trí";
									}
								}
							}
						}
					
						_detail.messageError = "";
						errorMessageArray.forEach(elementMessage => {
							if(elementMessage != "null"){
								_detail.messageError += elementMessage;
							}
						})
						if(_detail.messageError[0] == ";")
							_detail.messageError = _detail.messageError.substring(1).trim();
						if(_detail.messageError[_detail.messageError.length - 1] == ";")
							_detail.messageError = _detail.messageError.substring(0, _detail.messageError.length - 1).trim();

						if(!_detail.isError){
							let indexDetail = this.tmpChiTietNK.findIndex(x => x.IdHh == _detail.IdHh 
																			&& x.IdKho == _detail.IdKho
																			&& x.Solo == _detail.Solo
																			&& x.Handung == _detail.Handung);
							if(indexDetail > -1){
								this.tmpChiTietNK[indexDetail].Soluongthucnhap = '' + (Number(_detail.Soluongthucnhap) + Number(this.tmpChiTietNK[indexDetail].Soluongthucnhap));
							}
							else{
								this.tmpChiTietNK.push(_detail);
								let filterTmp = new ReplaySubject<any[]>(1)
								filterTmp.next(this.listKho.slice());
								this.arrayKhoForEachHH.push(filterTmp);
		
								let filterVTK = new ReplaySubject<any[]>(1)
								this.arrayVTKhoForEachHH.push(filterVTK);
								this.SaveListVTK.push([]);
		
								this.getDS_ViTriKho_Empty(_detail.IdKho,_detail);
							}
						}
						else{
							this.tmpChiTietNK.push(_detail);
							let filterTmp = new ReplaySubject<any[]>(1)
							filterTmp.next(this.listKho.slice());
							this.arrayKhoForEachHH.push(filterTmp);
	
							let filterVTK = new ReplaySubject<any[]>(1)
							this.arrayVTKhoForEachHH.push(filterVTK);
							this.SaveListVTK.push([]);
						}
					}
					else{
						this.layoutUtilsService.showErorr('Lỗi đọc dữ liệu file, vui lòng thử lại');
						return;
					}
				})
				this.tmpChiTietNK = [...this.tmpChiTietNK];
				this.processImport = false;
				this.NKForm.controls['LoaiPhieu'].enable();
				this.changeDetectView();
			}
		});

		this.applyComlumnsAferChangeLoaiPhieu();
		this.showColumnsInTable();
		this.applySelectedColumns();

	}
	ngOnDestroy() {
		this.clearDataImport();
	}
	/* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
	createForm(){
		
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.NKItem.Nguoitao = +idUser;
		this.minDate = new Date();

		if(this.NKItem.IdNk > 0){
			this.NKItem.listNguoiThucHien.forEach(element =>{
				this.listNguoiThucHien.push('' + element.NguoiThucHien);
			})
		}

		/*Group các Form */
		this.NKForm = this.NKFB.group({
			SoPhieu: [!(this.NKItem.Sophieu == undefined || this.NKItem.Sophieu == '') ? this.NKItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.NKItem.Ngaytao == undefined || this.NKItem.Ngaytao == '') ? this.NKItem.Ngaytao : new Date(), Validators.required],
			TenNguoiLap: [this.NKItem.IdNk > 0 ? this.NKItem.TenNguoitao : tenNguoiLap],
            TrangThai: [this.nameState],
            LoaiPhieu: [!(this.NKItem.LoaiPhieu == undefined || this.NKItem.LoaiPhieu == '')? this.NKItem.LoaiPhieu : PhieuNhapKho.optionsLoaiPhieu[2].value, Validators.required],
            NgayNhapKho: [!(this.NKItem.Ngaynhapkho == undefined || this.NKItem.Ngaynhapkho == '') ? this.NKItem.Ngaynhapkho : new Date(), Validators.required],
            DSNguoiThucHien: [this.listNguoiThucHien,Validators.required],
            DienGiai: [!(this.NKItem.DienGiai == undefined || this.NKItem.DienGiai == '') ? this.NKItem.DienGiai : '']
		});

		if(this.NKForm.controls["LoaiPhieu"].value == PhieuNhapKho.optionsLoaiPhieu[2].value){
			this.NKForm.controls["DienGiai"].setValidators([Validators.required]);
			this.NKForm.controls['DienGiai'].updateValueAndValidity()
		}

		this.flagChangeLoaiPhieu = this.NKForm.controls['LoaiPhieu'].value;

		/*Disable các trường dữ liệu không thay đổi */
        this.NKForm.controls["SoPhieu"].disable();
        this.NKForm.controls["NgayLapPhieu"].disable();
        this.NKForm.controls["TenNguoiLap"].disable();
        this.NKForm.controls["TrangThai"].disable();
        /*------------------------------------------------------------------*/

		this.HHForm = this.HHFB.group({
			MaHang: ['',Validators.required],
			TenHang: [''],
			QuyCach: [''],
            DVT: [''],
            Solo: ['',Validators.required],
			SoLuong:[ PhieuNhapKho.DEFAULT_NUMBER_VALUE, 
				Validators.compose([Validators.required, 
					Validators.min(0.01),
					Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
            ],
            HanSuDung: [new Date(), Validators.required],
            Kho: ['',Validators.required],
			ViTriKho: [''],
			SoMay: [''],
			NgaySanXat: [new Date()]
        });
        /*Disable các trường dữ liệu không thay đổi */
		this.HHForm.controls["TenHang"].disable();
		this.HHForm.controls["QuyCach"].disable();
		this.HHForm.controls["DVT"].disable();
		/*------------------------------------------------------------------*/

		this.ImportHHForm = this.ImportFB.group({
			FileDuLieu: [''],
		});
		/*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết*/
		if(this.NKItem.listChiTietPhieuNhapKho.length > 0){
			this.listChiTietNK = this.NKItem.listChiTietPhieuNhapKho;
			this.tmpChiTietNK = [];
			for(let i = 0; i < this.listChiTietNK.length; i++){
				let tmpElement = new ChiTietPhieuNhapKho();
				tmpElement.copy(this.listChiTietNK[i])
				this.tmpChiTietNK.push(tmpElement);
				let filterVTK = new ReplaySubject<any[]>(1)
				this.arrayVTKhoForEachHH.push(filterVTK);
				this.SaveListVTK.push([]);

				this.getDS_ViTriKho_Empty(tmpElement.IdKho,tmpElement);
			}
			
			this.tmpChiTietNK = [...this.tmpChiTietNK];
        }
		
        this.changeDetectView();
	}
	getTitle(): string {
		if (this.NKItem.IdNk > 0) {
			return `Chỉnh sửa phiếu nhập kho`;
		}
		return 'Thêm mới phiếu nhập kho';
    }
    getNameButtonDS(): string{
        if(this.NKForm.controls["LoaiPhieu"].value == PhieuNhapKho.optionsLoaiPhieu[0].value){
            return 'Chọn hàng từ phiếu TTHV';
        }
		else if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[1].value){
			return 'Chọn hàng từ phiếu ĐNNK';
		}
        return '';
	}
	
	holdValueLoaiPhieuBeforeChange(){
		this.NKForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString());
		this.changeDetectView();
	}
	checkChangeLoaiPhieu(value: any){
		if(this.tmpChiTietNK.length == 0){
			this.NKForm.controls['LoaiPhieu'].setValue(value.toString())
			this.flagChangeLoaiPhieu = this.NKForm.controls['LoaiPhieu'].value
			this.acceptChangeLoaiPhieu();
		}
		else if(value != this.NKForm.controls['LoaiPhieu'].value){
			const dialogRef = this.layoutUtilsService.POPConfirm();
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.NKForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString())
					return;
				}
				this.NKForm.controls['LoaiPhieu'].setValue(value.toString())
				this.flagChangeLoaiPhieu = this.NKForm.controls['LoaiPhieu'].value
				this.acceptChangeLoaiPhieu();
			});
		}
	}
	acceptChangeLoaiPhieu(){
		this.listChiTietNK = [];
		this.tmpChiTietNK = [];
		this.tmpChiTietNK = [...this.tmpChiTietNK];

		this.arrayKhoForEachHH = [];
		this.arrayVTKhoForEachHH = [];

		// this.select = [];
		// this.selectedHXL = [];

		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(PhieuNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["HanSuDung"].setValue(new Date());
		this.HHForm.controls["MaHang"].enable();
		this.HHForm.controls["NgaySanXat"].setValue(new Date());

		this.applyComlumnsAferChangeLoaiPhieu();
		this.applySelectedColumns();
		this.changeDetectView();

	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyComlumnsAferChangeLoaiPhieu(){
		if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[0].value){
			this.availableColumns = this.phieuTTHVColumn
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[1].value){
			this.availableColumns = this.phieuDNNKColumn
		}
		else{
			this.availableColumns = this.tmpAvailableColumns
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState(){
		this.dungChungService.listState(PhieuNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.NKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.NKForm != null)
					this.NKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListKho(){
		this.dungChungService.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKho = res.data;
				this.tmpChiTietNK.forEach(element =>{
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listKho.slice());
					this.arrayKhoForEachHH.push(filterTmp);
				})
				this.changeDetectView();
			};
		});
	}
	filterListKho(item: any) {
		if (!this.listKho) {
			return;
		}
		let search = this.KhoFilterCtrl;
		let index = this.tmpChiTietNK.indexOf(item)

		if (!search) {
			this.arrayKhoForEachHH[index].next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if(index > -1){
			this.arrayKhoForEachHH[index].next(this.listKho.filter(ts => 
				ts.TenKho.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	ListKhoVer2(){
		this.dungChungService.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoVer2 = res.data;
				this.filteredKhoVer2.next(this.listKhoVer2.slice());
				this.changeDetectView();
			};
		});
	}
	filterListKhoVer2() {
		if (!this.listKhoVer2) {
			return;
		}
		let search = this.KhoFilterCtrlVer2;
		if (!search) {
			this.filteredKhoVer2.next(this.listKhoVer2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoVer2.next(
			this.listKhoVer2.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	getNameOfKho(IdKho: number){
		let name = '';
		this.listKhoVer2.forEach(element =>{
			if(element.Id_Kho == IdKho){
				name = element.TenKho
			}
		})
		return name;
	}

	getDS_ViTriKho_Empty(IdKho: number, item: any){
		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.nhapKhoService.getDSVTK(IdKho).subscribe(res => {
			if(res && res.status == 1){
				if(res.data != null){
					listVTK_Full = res.data.listVTK;
					hKhoMax = res.data.hKho;
					cKhoMax = res.data.cKho;
					tKhoMax = res.data.tKho;
					for(let t = tKho; t <= tKhoMax; t++){
						for(let c = cKho; c <= cKhoMax; c++){
							for(let h = hKho; h <= hKhoMax; h++){
								let value = this.lpad(h,3)+"."+this.lpad(c,3)+"."+this.lpad(t,2);
								if(listVTK_Full.findIndex(x => x == value) == -1){
									listVTK_Empty.push(value);
								}
							}
						}
					}
				}
				let _index = this.tmpChiTietNK.findIndex(x => x.IdHh == item.IdHh 
					&& x.IdKho == item.IdKho
					&& x.Solo == item.Solo
					&& x.Handung == item.Handung
					&& x.ViTriKho == item.ViTriKho)
				if(_index > -1){
					this.SaveListVTK[_index] = listVTK_Empty;
					this.arrayVTKhoForEachHH[_index].next(listVTK_Empty.slice());

					if(item.ViTriKho != null && item.ViTriKho != undefined && item.ViTriKho != ''){
						let _tmpIndex = this.SaveListVTK[_index].findIndex(x => x == item.ViTriKho)
						if(_tmpIndex == -1){
						this.tmpChiTietNK[_index].ViTriKho = ''
						}
					}
				}
			}
		});
	}
	filterListVTKho(item: any) {
		let _index = this.tmpChiTietNK.findIndex(x => x.IdHh == item.IdHh 
												&& x.IdKho == item.IdKho
												&& x.Solo == item.Solo
												&& x.Handung == item.Handung)
		if(_index > -1){
			if (!this.SaveListVTK[_index]) {
				return;
			}
			let search = this.VTKhoFilterCtrl;

			if (!search) {
				this.arrayVTKhoForEachHH[_index].next(this.SaveListVTK[_index].slice());
				return;
			} else {
				search = search.toLowerCase();
			}
			this.arrayVTKhoForEachHH[_index].next(this.SaveListVTK[_index].filter(ts => 
				ts.toLowerCase().indexOf(search) > -1)
			);
			this.changeDetectView();
		}
	}
	resetViTriKho(item:any){
		let _index = this.tmpChiTietNK.findIndex(x => x.IdHh == item.IdHh 
													&& x.IdKho == item.IdKho
													&& x.Solo == item.Solo
													&& x.Handung == item.Handung)
		if(_index > -1){
			this.tmpChiTietNK[_index].ViTriKho = "";
			this.changeDetectView();
		}
	}
	getDS_ViTriKho_EmptyVer2(IdKho: any){
		if(IdKho == null || IdKho == 0){
			this.ListVTKVer2 = [];
			return;
		}
		this.filteredVTKhoVer2.next([]);
		this.HHForm.controls['ViTriKho'].setValue('');
		
		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.nhapKhoService.getDSVTK(Number(IdKho)).subscribe(res => {
			if(res && res.status == 1){
				if(res.data != null){
					listVTK_Full = res.data.listVTK;
					hKhoMax = res.data.hKho;
					cKhoMax = res.data.cKho;
					tKhoMax = res.data.tKho;
					for(let t = tKho; t <= tKhoMax; t++){
						for(let c = cKho; c <= cKhoMax; c++){
							for(let h = hKho; h <= hKhoMax; h++){
								let value = this.lpad(h,3)+"."+this.lpad(c,3)+"."+this.lpad(t,2);
								if(listVTK_Full.findIndex(x => x == value) == -1){
									listVTK_Empty.push(value);
								}
							}
						}
					}
					this.ListVTKVer2 = listVTK_Empty;
					this.filteredVTKhoVer2.next(listVTK_Empty.slice());
					this.changeDetectView();
				}
				else{
					this.ListVTKVer2 = [];
					this.filteredVTKhoVer2.next(this.ListVTKVer2.slice());
				}
			}
		});
		this.isDisableButton();
	}
	filterListVTKhoVer2() {
		if (!this.ListVTKVer2) {
			return;
		}
		let search = this.VTKhoFilterCtrlVer2;
		if (!search) {
			this.filteredVTKhoVer2.next(this.ListVTKVer2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredVTKhoVer2.next(
			this.ListVTKVer2.filter(ts =>
				ts.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearViTriKho(event: any){
		this.HHForm.controls["ViTriKho"].setValue('');
		event.stopPropagation();
		this.changeDetectView();
	}
	chonViTriKho(IdKho: any,type: number, index:any){
		let _index = this.listKho.findIndex(x => x.Id_Kho == IdKho);
		if(_index > -1){
			if(this.listKho[_index].CoSoDoKho){
				const dialogRef = this.dialog.open(SoDoKhoViewVer2Component, {
					data: {
						data: this.listKho[_index],
						type: type,
						currentSelected: type == 0 ? this.HHForm.controls['ViTriKho'].value : this.tmpChiTietNK[index].ViTriKho
					},
					maxHeight: '90vh',
					width: '90vw'
				});
				dialogRef.afterClosed().subscribe(res => {
					if (res == undefined || res == null) {
						return;
					}
					else {
						if (res.vitrikho != null && res.vitrikho != '') {
							
							if(type == 0)
								this.HHForm.controls["ViTriKho"].setValue(res.vitrikho[0])
							else if(type == 1){
								this.tmpChiTietNK[index].ViTriKho = res.vitrikho[0];
								for(let i = 1; i < res.vitrikho.length; i++){
									let tmp = new ChiTietPhieuNhapKho();
									tmp.copy(this.tmpChiTietNK[index]);
									tmp.ViTriKho = res.vitrikho[i];
									tmp.Soluongthucnhap = PhieuNhapKho.DEFAULT_NUMBER_VALUE;

									this.tmpChiTietNK.push(tmp);

									let filterTmp = new ReplaySubject<any[]>(1)
									filterTmp.next(this.listKho.slice());
									this.arrayKhoForEachHH.push(filterTmp);
						
									let filterVTK = new ReplaySubject<any[]>(1)
									this.arrayVTKhoForEachHH.push(filterVTK);
									this.SaveListVTK.push([]);
						
									this.getDS_ViTriKho_Empty(tmp.IdKho,tmp);
									this.tmpChiTietNK = [...this.tmpChiTietNK];
								}
								
							}
							this.changeDetectView();
						}
					}
				});
			}
			else{
				this.layoutUtilsService.showErorr('Kho chưa thiết lập sơ đồ kho');
				return;
			}
		}
		else{
			this.layoutUtilsService.showErorr('Không tìm được thông tin kho đang chọn');
			return;
		}
	}

	ListIdNv(){
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		this.dungChungService.listNVTheoPB(+phongban).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listIdNV = res.data;
				this.filteredIdNV.next(this.listIdNV.slice());
				this.changeDetectView();
			};
		});
	}
	filterIdNv() {
		if (!this.listIdNV) {
			return;
		}
		let search = this.IdNVFilterCtrl;
		if (!search) {
			this.filteredIdNV.next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdNV.next(
			this.listIdNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearSelectNV(event: any){
		this.NKForm.controls["DSNguoiThucHien"].setValue('');
		event.stopPropagation();
	}

	ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.sumRecord = this.listId_HH.filter(ts =>ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}
		
		this.changeDetectView();
	}
	afterSelectHH(value:string){
		this.listId_HH.forEach( element => {
			if(element.Id_HH == +value){
				this.selectId_HH = value;
				this.HHForm.controls["MaHang"].setValue(element.MaHH);
				this.HHForm.controls["MaHang"].disable();
				this.HHForm.controls["TenHang"].setValue(element.TenHH);
				this.HHForm.controls["QuyCach"].setValue(element.QuyCach);
				this.HHForm.controls["DVT"].setValue(element.TenDVT);
				//this.validateInvalidSubForm();
			}
		});
		this.isDisableButton();
	}
	clearSelectHH(event: any){
		this.selectId_HH = '';
		this.HHForm.controls["MaHang"].setValue('');
		this.HHForm.controls["MaHang"].enable();

		this.HHForm.controls["TenHang"].setValue('');
		this.HHForm.controls["QuyCach"].setValue('');
		this.HHForm.controls["DVT"].setValue('');
		this.sumRecord = this.listId_HH.length;

		event.stopPropagation();
		this.isDisableButton();
	}
	checkCanPhieuKT(idHH: any){
		let index = this.listId_HH.findIndex(x => x.Id_HH == idHH)
		if(index > -1 && this.listId_HH[index].CanPhieuKT != null 
			&& this.listId_HH[index].CanPhieuKT != undefined && !this.listId_HH[index].CanPhieuKT){
			return true;
		}
		return false;
	}
	isRequiredPhieuKT(item: any){
		if(!this.checkCanPhieuKT(item.IdHh) && item.Tinhtrang 
				&& (item.Phieukiemtracl == null || item.Phieukiemtracl == '')){
			return true;
		}
		return false;
	}

	changeLoaiPhieu(){
		this.listChiTietNK = [];
		this.tmpChiTietNK = [];
		this.tmpChiTietNK = [...this.tmpChiTietNK];
		this.arrayVTKhoForEachHH = [];
		this.arrayKhoForEachHH = [];
		this.SaveListVTK = [];
		this.clearDataImport();

		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(PhieuNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["HanSuDung"].setValue(new Date());
		this.HHForm.controls["MaHang"].enable();
		this.selectId_HH = '';
		this.filteredId_HH.next(this.listId_HH.slice());

		this.ImportHHForm.reset();

		this.listKhoVer2 = [];
		this.filteredVTKhoVer2 = new ReplaySubject<any[]>(1);

		this.NKForm.controls["DienGiai"].setValidators(null);
		this.NKForm.controls['DienGiai'].updateValueAndValidity()
		
		if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[2].value){
			this.NKForm.controls["DienGiai"].setValidators([Validators.required]);
			this.NKForm.controls['DienGiai'].updateValueAndValidity()
		}
		
		this.applyComlumnsAferChangeLoaiPhieu();
		this.applySelectedColumns();
		this.changeDetectView();
	}
	valueCheckboxChange(index:number, event: any){
		if(event != null && event != undefined)
			this.tmpChiTietNK[index].Tinhtrang = event.checked;
	}
	/* -----------------------------------------------------------------------*/
	

    /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return PhieuNhapKho.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			}else{
				event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
			}
			
			//this.changeDetect.detectChanges();
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){
		
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.formatComparenumber(event.target.value.toString());
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = this.f_currency_VND(this.formatNumber(tmpValue.toString()));
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			
			item[columnName] = this.f_currency_VND(this.formatNumber(tmpValue.toString()));
		}
		else{
			item[columnName] =this.f_currency_VND(this.formatNumber(min.toString()));
		}

		this.changeDetectView();
	}
	lpad(value, padding) {
		var zeroes = new Array(padding+1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietNK = [...this.tmpChiTietNK];
		}
		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/

	
   	/*---------------------------- Thao tác trên form ------------------------*/
   	back(){
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd : this.saveAdded,
			}
		);
	}
	addMoreDetail(){
		if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[0].value ){

			this.deletedItems = [];
			this.addNewItems = [];
			//Check add các hàng đã có trong DB mà đã xóa khỏi phiếu hiện tại
			this.listChiTietNK.forEach(element => {
				let _index = this.tmpChiTietNK.findIndex(x => x.IdCtdn == element.IdCtdn)
				if(_index == -1 ){
					this.deletedItems.push(element.IdCtdn)
				}
			})

			//Check hàng mới vừa được thêm vào danh sách hàng hiện tại để load lại list
			this.tmpChiTietNK.forEach(element =>{
				this.addNewItems.push(element.IdCtdn)
			})

			const dialogRef = this.dialog.open(ThongTinHangVeListDialogComponent, {
				data: {
					data: this.tmpChiTietNK,
					deleted: this.deletedItems,
					add: this.addNewItems
				},
				maxHeight: '90vh',
				width: '90vw'
			});
	
			dialogRef.afterClosed().subscribe(res => {
				if (res == undefined || res == null) {
					return;
				}
				else{
					
					if(res.dataAdd != null && res.dataAdd.length > 0){
						for(let i = 0; i < res.dataAdd.length; i++){
							let element = res.dataAdd[i];
							let tmp = new ChiTietPhieuNhapKho();
							tmp.clear();
							tmp.IdHh= element.IdHh;
							tmp.TenHH = element.TenHH;
							tmp.MaHH= element.MaHH;
							tmp.DungSai = element.DungSai;
							tmp.QuyCach = element.QuyCach;
							tmp.Dvt= element.Dvt;
							tmp.TenDVT = element.TenDVT;
							tmp.IdCtdn= element.IdCtdn;
							tmp.IdNcc= element.IdNcc;
							tmp.Soluongthucnhap= element.Soluongchungtu;
							tmp.Soluongchungtu = element.Soluongchungtu;
							tmp.SoPhieuDN = element.SoPhieuDN;
							tmp.Solo = element.Solo;
							tmp.Handung = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
							tmp.IdLo = element.IdLo;
							this.tmpChiTietNK.push(tmp);

							let filterTmp = new ReplaySubject<any[]>(1)
							filterTmp.next(this.listKho.slice());
							this.arrayKhoForEachHH.push(filterTmp);

							let filterVTK = new ReplaySubject<any[]>(1)
							this.arrayVTKhoForEachHH.push(filterVTK);
							this.SaveListVTK.push([]);
						}
						this.tmpChiTietNK = [...this.tmpChiTietNK];
						this.changeDetectView();
					}
				}
			});
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[1].value){
			
			this.deletedItems = [];
			this.addNewItems = [];
			//Check add các hàng đã có trong DB mà đã xóa khỏi phiếu hiện tại
			this.listChiTietNK.forEach(element => {
				let _index = this.tmpChiTietNK.findIndex(x => x.IdCtdn == element.IdCtdn)
				if(_index == -1 ){
					this.deletedItems.push(element.IdCtdn)
				}
			})

			//Check hàng mới vừa được thêm vào danh sách hàng hiện tại để load lại list
			this.tmpChiTietNK.forEach(element =>{
				let _index = this.listChiTietNK.findIndex( x => x.IdCtdn == element.IdCtdn)
				if(_index == -1){
					this.addNewItems.push(element.IdCtdn)
				}
			})

			const dialogRef = this.dialog.open(DNNKListDialogComponent, {
				data: {
					data: this.tmpChiTietNK,
					deleted: this.deletedItems,
					add: this.addNewItems
				},
				maxHeight: '90vh',
				width: '90vw'
			});
	
			dialogRef.afterClosed().subscribe(res => {
				if (res == undefined || res == null) {
					return;
				}
				else{
					if(res.dataAdd != null && res.dataAdd.length > 0){
						for(let i = 0; i < res.dataAdd.length; i++){
							let element = res.dataAdd[i];
							let tmp = new ChiTietPhieuNhapKho();
							tmp.clear();
							tmp.IdHh= element.IdHh;
							tmp.TenHH = element.TenHH;
							tmp.MaHH= element.MaHH;
							tmp.DungSai = element.DungSai;
							tmp.QuyCach = element.QuyCach;
							tmp.Dvt= element.Dvt;
							tmp.TenDVT = element.TenDVT;
							tmp.IdCtdn= element.IdCtdn;
							tmp.IdNcc= element.IdNcc;
							tmp.Soluongthucnhap= element.Soluongchungtu;
							tmp.Soluongchungtu = element.Soluongchungtu;
							tmp.SoPhieuDN = element.SoPhieuDN;
							tmp.Solo = element.Solo;
							tmp.Handung = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
							tmp.IdLo = element.IdLo;
							tmp.SoMay = element.SoMay;
							tmp.NgaySanXat = element.NgaySanXat;

							this.tmpChiTietNK.push(tmp);

							let filterTmp = new ReplaySubject<any[]>(1)
							filterTmp.next(this.listKho.slice());
							this.arrayKhoForEachHH.push(filterTmp);

							let filterVTK = new ReplaySubject<any[]>(1)
							this.arrayVTKhoForEachHH.push(filterVTK);
							this.SaveListVTK.push([]);
						}
						this.tmpChiTietNK = [...this.tmpChiTietNK];
						this.changeDetectView();
					}
				}
			});
		}
	}
	addDetail(){
		const _detail = new ChiTietPhieuNhapKho();
		_detail.clear();

		let index = this.listId_HH.findIndex(x => x.Id_HH == +this.selectId_HH)
		if(index > -1){
			_detail.MaHH = this.listId_HH[index].MaHH;
			_detail.TenHH = this.listId_HH[index].TenHH;
			_detail.QuyCach = this.listId_HH[index].QuyCach;
			_detail.TenDVT = this.listId_HH[index].TenDVT;
			_detail.Dvt = this.listId_HH[index].DVT;
			if(this.listId_HH[index].CanPhieuKT == false){
				_detail.Tinhtrang = true;
			}
		}

		_detail.IdHh = +this.selectId_HH;
		_detail.Soluongthucnhap = this.HHForm.controls['SoLuong'].value;
		_detail.Solo = this.HHForm.controls["Solo"].value;
		_detail.Handung = moment(this.HHForm.controls["HanSuDung"].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_detail.HanSuDung = moment(this.HHForm.controls["HanSuDung"].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_detail.IdKho = +this.HHForm.controls["Kho"].value;
		_detail.ViTriKho = this.HHForm.controls["ViTriKho"].value;
		_detail.SoMay = this.HHForm.controls["SoMay"].value;
		_detail.NgaySanXat = moment(new Date(this.HHForm.controls["NgaySanXat"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');

		const message = `Thông tin hàng nhập kho đã được thêm.`;
		this.layoutUtilsService.showInfo(message);
	
		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(PhieuNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["HanSuDung"].setValue(new Date());
		this.HHForm.controls["MaHang"].enable();
		this.HHForm.controls["NgaySanXat"].setValue(new Date());

		this.selectId_HH = '';
		this.filteredId_HH.next(this.listId_HH.slice());

		this.filteredVTKhoVer2 = new ReplaySubject<any[]>(1);

		let indexDetail = this.tmpChiTietNK.findIndex(x => x.IdHh == _detail.IdHh 
													&& x.IdKho == _detail.IdKho
													&& x.Solo == _detail.Solo
													&& this.getFormatDate(x.Handung) == this.getFormatDate(_detail.Handung)
													&& x.ViTriKho == _detail.ViTriKho);

		if(indexDetail > -1){
			this.tmpChiTietNK[indexDetail].Soluongthucnhap = '' + (this.formatComparenumber(_detail.Soluongthucnhap == null ? PhieuNhapKho.DEFAULT_NUMBER_VALUE : _detail.Soluongthucnhap.toString()) 
			+ this.formatComparenumber(this.tmpChiTietNK[indexDetail].Soluongthucnhap == null ? PhieuNhapKho.DEFAULT_NUMBER_VALUE : this.tmpChiTietNK[indexDetail].Soluongthucnhap.toString()));
		}
		else{
			this.tmpChiTietNK.push(_detail);
			this.saveAddedCT.push(this.tmpChiTietNK.findIndex(x => x == _detail));

			let filterTmp = new ReplaySubject<any[]>(1)
			filterTmp.next(this.listKho.slice());
			this.arrayKhoForEachHH.push(filterTmp);

			let filterVTK = new ReplaySubject<any[]>(1)
			this.arrayVTKhoForEachHH.push(filterVTK);
			this.SaveListVTK.push([]);

			this.getDS_ViTriKho_Empty(_detail.IdKho,_detail);
		}

		this.tmpChiTietNK = [...this.tmpChiTietNK];
		this.disableNewButton = true;
		this.scrollToBottom();
		this.changeDetectView();

	}
	afterChangeRecord(item:ChiTietPhieuNhapKho, index: number){
		
		let isContain = false;
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(index != i && item.IdHh == this.tmpChiTietNK[i].IdHh 
				&& item.IdKho == this.tmpChiTietNK[i].IdKho
				&& item.Solo == this.tmpChiTietNK[i].Solo
				&& this.getFormatDate(item.Handung) == this.getFormatDate(this.tmpChiTietNK[i].Handung)
				&& item.ViTriKho == this.tmpChiTietNK[i].ViTriKho){
					this.tmpChiTietNK[i].Soluongthucnhap = '' + (this.formatComparenumber(item.Soluongthucnhap == null ? PhieuNhapKho.DEFAULT_NUMBER_VALUE : item.Soluongthucnhap.toString()) 
							+ this.formatComparenumber(this.tmpChiTietNK[i].Soluongthucnhap == null ? PhieuNhapKho.DEFAULT_NUMBER_VALUE : this.tmpChiTietNK[i].Soluongthucnhap.toString()));
					isContain = true;
					break;
			}
		}
		if(isContain){
			this.tmpChiTietNK.splice(index, 1);
			this.arrayKhoForEachHH.splice(index, 1);
			this.arrayVTKhoForEachHH.splice(index, 1);
			this.SaveListVTK.splice(index, 1);

			this.tmpChiTietNK = [...this.tmpChiTietNK];
			this.changeDetectView();
		}
	}
	onSubmit(type: number) {
		const controls = this.NKForm.controls;

		if (this.NKForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			document.getElementById('dialog-form').scrollTo({ top: 0, behavior: 'smooth' });
			return false;
		}

		if (this.tmpChiTietNK.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng nhập kho');
			return null;
		}

		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(!this.tmpChiTietNK[i].isError){
				if(!this.ValidateChangeNumberForm(this.tmpChiTietNK[i].Soluongthucnhap,false)){
					return null;
				}
				else if(Number(this.tmpChiTietNK[i].Soluongthucnhap) <= 0){
					this.layoutUtilsService.showErorr('Số lượng của mã hàng '+ this.tmpChiTietNK[i].MaHH + ' không được <= 0');
					return null;
				}
				else if(this.tmpChiTietNK[i].Handung == null || this.tmpChiTietNK[i].Handung == undefined || this.tmpChiTietNK[i].Handung == ''){
					this.layoutUtilsService.showErorr('Hạn dùng của mã hàng ' + this.tmpChiTietNK[i].MaHH + ' không được để trống');
					return null;
				}
				else if(this.tmpChiTietNK[i].Solo == null || this.tmpChiTietNK[i].Solo == undefined || this.tmpChiTietNK[i].Solo == ''){
					this.layoutUtilsService.showErorr('Số lô của mã hàng ' + this.tmpChiTietNK[i].MaHH + ' không được để trống');
					return null;
				}
				else if(this.tmpChiTietNK[i].IdKho == null || this.tmpChiTietNK[i].IdKho == undefined || this.tmpChiTietNK[i].IdKho <= 0){
					this.layoutUtilsService.showErorr('Vui lòng chọn kho nhập cho mã hàng ' + this.tmpChiTietNK[i].MaHH);
					return null;
				}
				else if(!this.checkCanPhieuKT(this.tmpChiTietNK[i].IdHh) && this.tmpChiTietNK[i].Tinhtrang 
						&& (this.tmpChiTietNK[i].LyDoChoPhepXuat == null || this.tmpChiTietNK[i].LyDoChoPhepXuat == '')){
					this.layoutUtilsService.showErorr('Vui lòng nhập lý do cho phép xuất kho cho mã hàng ' + this.tmpChiTietNK[i].MaHH);
					return null;
				}
			}
		}

		
		const _result = new PhieuNhapKho();
		_result.clear();
		_result.Sophieu = controls["SoPhieu"].value;
		_result.Ngaynhapkho = moment(new Date(controls["NgayNhapKho"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS'); // tmp Value but insert today in API
		_result.Tinhtrang = PhieuNhapKho.optionsTinhTrang[0].value;
		if(type == 1 || type == 2){
			_result.Tinhtrang = PhieuNhapKho.optionsTinhTrang[1].value;
		}
		_result.LoaiPhieu = controls["LoaiPhieu"].value;
		_result.DienGiai = controls["DienGiai"].value;
		let tmpList = [];
		this.tmpChiTietNK.forEach(element =>{
			if(!element.isError){
				if(element.IdNcc == null || element.IdNcc == undefined)
					element.IdNcc = 0;
				element.Handung = moment(new Date(element.Handung)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				element.HanSuDung = moment(new Date(element.Handung)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				element.SoLuongThucNhap = element.Soluongthucnhap;
				tmpList.push(element)
			}
		})
		_result.listChiTietPhieuNhapKho = tmpList;

		let listNguoiThucHienTmp: NguoiThucHienNhapKho[] = [];
		if(controls["DSNguoiThucHien"].value != null && controls["DSNguoiThucHien"].value.length > 0){
			for(let i = 0; i < controls["DSNguoiThucHien"].value.length; i++){
				let tmpElement = new NguoiThucHienNhapKho();
				tmpElement.clear();
				tmpElement.NguoiThucHien = controls["DSNguoiThucHien"].value[i]

				listNguoiThucHienTmp.push(tmpElement);
			}
		}
		_result.listNguoiThucHien = listNguoiThucHienTmp;

		if(type == 1 || type == 2){
			const dialogRef = this.layoutUtilsService.POP02(_result.Sophieu);

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				if (this.NKItem.IdNk > 0) {
					_result.IdNk = this.NKItem.IdNk;
					this.updateNhapKho(_result,type);
					return;
				}
				this.addNhapKho(_result,type);
			});
		}
		else{
			if (this.NKItem.IdNk > 0) {
				_result.IdNk = this.NKItem.IdNk;
				this.updateNhapKho(_result,type);
				return;
			}
			this.addNhapKho(_result,type);
		}
		
	}
	updateNhapKho(item: PhieuNhapKho, withBack: number) {
		this.nhapKhoService.updateWithDetail(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu nhập kho cập nhập thành công`;
				this.layoutUtilsService.showInfo(message);

				let index = this.saveAdded.findIndex(x => x == res.data.IdNk);
				if(index == -1)
				this.saveAdded.push(res.data.IdNk);
				this.isChange = true;
				
				if(withBack == 1){
					this.back();
				}
				else{
					this.NKForm.controls["TrangThai"].setValue(PhieuNhapKho.optionsTinhTrang[0].name);
					this.clearDataImport();
					if(withBack == 2){
						this.dungChungService.getBillNumber(PhieuNhapKho.category_path).subscribe(resNextSP => {
							if (resNextSP.status == 1) {
								let tmpSaveLoaiPhieu = this.NKForm.controls["LoaiPhieu"].value;
								this.NKForm.reset();
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
								
								this.NKForm.controls["SoPhieu"].setValue("NK" + resNextSP.data);
								this.NKForm.controls["NgayLapPhieu"].setValue(new Date());
								this.NKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.NKForm.controls["LoaiPhieu"].setValue(tmpSaveLoaiPhieu);
								this.NKForm.controls["NgayNhapKho"].setValue(new Date());
								this.NKForm.controls["DSNguoiThucHien"].setValue('');
								this.NKForm.controls["DienGiai"].setValue('');
								
								if(this.NKForm.controls["LoaiPhieu"].value == 'Nhập kho khác'){
									this.HHForm.reset();
									this.HHForm.controls["MaHang"].enable();
									this.HHForm.controls["SoLuong"].setValue('0.00');
									this.HHForm.controls["HanSuDung"].setValue(new Date());
									this.HHForm.controls["NgaySanXat"].setValue(new Date());
									
									this.ImportHHForm.reset();
								}
								this.sumRecord = this.listId_HH.length;

								this.listChiTietNK = [];
								this.tmpChiTietNK = [];
								this.tmpChiTietNK = [...this.tmpChiTietNK];
								this.arrayVTKhoForEachHH = [];
								this.arrayKhoForEachHH = [];
								this.SaveListVTK = [];

								this.NKItem.IdNk = 0;
								this.NKItem.Sophieu = "NK" + resNextSP.data;
								this.title = this.getTitle();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	addNhapKho(item: PhieuNhapKho, withBack: number){
		this.nhapKhoService.add(item).subscribe(res => {
			if (res.status == 1) {

				const message = `Phiếu nhập kho mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
	
				let index = this.saveAdded.findIndex(x => x == res.data.IdNk);
				if(index == -1)
					this.saveAdded.push(res.data.IdNk);
				this.isChange = true;

				res.data.listChiTietPhieuNhapKho.forEach(element =>{
					let index = this.tmpChiTietNK.findIndex(x => x.IdCtdn == element.IdCtdn);
					if(index > -1){
						this.tmpChiTietNK[index].IdLo = element.IdLo;
					}
				})

				if(withBack == 1){
					this.back();
				}
				else{
					this.selectId_HH = '';
					this.filteredId_HH.next(this.listId_HH.slice());
					this.clearDataImport();
					if(withBack == 2){
						this.dungChungService.getBillNumber(PhieuNhapKho.category_path).subscribe(res => {
							if (res.status == 1) {

								let tmpSaveLoaiPhieu = this.NKForm.controls["LoaiPhieu"].value;
								this.NKForm.reset();
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
								
								this.NKForm.controls["SoPhieu"].setValue(res.data);
								this.NKForm.controls["NgayLapPhieu"].setValue(new Date());
								this.NKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
								this.NKForm.controls["TrangThai"].setValue(PhieuNhapKho.optionsTinhTrang[0].name);
								this.NKForm.controls["LoaiPhieu"].setValue(tmpSaveLoaiPhieu);
								this.NKForm.controls["NgayNhapKho"].setValue(new Date());
								this.NKForm.controls["DSNguoiThucHien"].setValue('');
								this.NKForm.controls["DienGiai"].setValue('');

								if(this.NKForm.controls["LoaiPhieu"].value == 'Nhập kho khác'){
									this.HHForm.reset();
									this.HHForm.controls["MaHang"].enable();
									this.HHForm.controls["SoLuong"].setValue('0.00');
									this.HHForm.controls["HanSuDung"].setValue(new Date());
									this.HHForm.controls["NgaySanXat"].setValue(new Date());

									this.ImportHHForm.reset();
								}
								this.sumRecord = this.listId_HH.length;

								this.listChiTietNK = [];
								this.tmpChiTietNK = [];
								this.tmpChiTietNK = [...this.tmpChiTietNK];
								this.arrayVTKhoForEachHH = [];
								this.arrayKhoForEachHH = [];
								this.SaveListVTK = [];

								this.NKItem.Sophieu = res.data;
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if(withBack == 3){
						this.NKForm.controls["TrangThai"].setValue(PhieuNhapKho.optionsTinhTrang[0].name);
						this.NKItem.IdNk = res.data.IdNk;
					}
					this.title = this.getTitle();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	deleteItem(item: any){
		const index = this.tmpChiTietNK.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietNK.splice(index, 1);
			this.arrayKhoForEachHH.splice(index, 1);
			this.arrayVTKhoForEachHH.splice(index, 1);
			this.SaveListVTK.splice(index, 1);
		}
		this.tmpChiTietNK = [...this.tmpChiTietNK];
	}
	clearErrorData(){
		for(let i = 0 ; i < this.tmpChiTietNK.length;i++){
			if(this.tmpChiTietNK[i].isError){
				this.arrayKhoForEachHH.splice(i, 1);
				this.arrayVTKhoForEachHH.splice(i, 1);
				this.SaveListVTK.splice(i, 1);
				this.tmpChiTietNK.splice(i, 1);
				i--;
			}
		}
		this.tmpChiTietNK = [...this.tmpChiTietNK];
	}
	checkErrorData(){
		for(let i = 0 ; i < this.tmpChiTietNK.length;i++){
			if(this.tmpChiTietNK[i].isError){
				return true;
			}
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/
	

	/*---------------------- Import file dữ liệu hàng hóa --------------------*/	
	selectFile() {
		let el: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			let file = evt.target.files[0];
			let fileName = file.name;
			var res = fileName.match(/.xlsx$/g);
			if (res) {
				if (!res["includes"]('.xlsx')) {
					this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
					return;
				}
				else {
					this.ImportHHForm.controls['FileDuLieu'].patchValue(fileName);
					this.NKForm.controls['LoaiPhieu'].disable();
					this.processImport = true;
					this.changeDetectView();
					this.Importfile();
				}
			}
			else {
				this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
				return;
			}
		}
		else {//Không có file
			this.ImportHHForm.controls['FileDuLieu'].patchValue('');
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	checkDataIsValid(): boolean {
		let p = document.getElementById("fileUploadExcel");
		return this.ImportHHForm.controls['FileDuLieu'] && this.ImportHHForm.controls['FileDuLieu'].valid && (p ? (p["type"] == 'file' ? p["files"]["length"] > 0 : false) : false);
	}
	Importfile() {
		let el: any = this.fileUploadImport.nativeElement;
		var service = this.nhapKhoService;

		for (var idx = 0; idx < el.files.length; idx++) {

			var extension = el.files[idx].name.split('.').pop();
			var fileName = el.files[idx].name.substring(0,el.files[idx].name.indexOf(extension) - 1);

			let reader = new FileReader();
			reader.readAsDataURL(el.files[idx]);

			reader.onload = function () {
				let base64Str = reader.result as String;
				var metaIdx = base64Str.indexOf(';base64,');
				base64Str = base64Str.substr(metaIdx + 8);

				var data = {
					fileName: fileName,
					base64: base64Str,
					extension: extension
				};

				service.lastFileUpload$.next(data);
				service.uploadFileImport(data).subscribe(res => {
					if (res && res.status == 1) {
						service.data_import.next(res.data);
					}
					else {
						service.lastFilterDSExcel$.next([]);
						service.lastFilterInfoExcel$.next(undefined);
						return;
					}
				});
			};
		}
	}
	ImportFileMau() {
		let linkdownload = this.nhapKhoService.downloadTemplate();
		window.open(linkdownload);
	}
	clearDataImport(){
		this.nhapKhoService.data_import.next([]);
	}
	/* -----------------------------------------------------------------------*/
    
	
	/*------------------------------ Extend Options --------------------------*/
	timKiemNangCao(){
		this.openTimKiemNangCao = true;
		
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.focusDetail.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}
	tabChange(event: MatTabChangeEvent){
		if(event.index == 0)
			this.flagTab = 0;
		else if(event.index == 1)
			this.flagTab = 1;
		this.clearDataImport();
		this.changeDetectView();
    }
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	isDisableButton(){
		if( this.HHForm.invalid || 
			this.HHForm.controls["TenHang"].value == null || 
			this.HHForm.controls["TenHang"].value == ''){
				this.disableNewButton = true;
		}
		else{
			this.disableNewButton = false;
		}
	}
	/* -----------------------------------------------------------------------*/
}